// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { API_ENDPOINTS } from "../api-urls";

// // Get authentication token
// const getAuthToken = () => {
//   const token = localStorage.getItem("authToken");
//   console.log("Auth Token:", token); // Debugging
//   return token ? `Bearer ${token}` : null;
// };

// // POST: Create a new custom size
// export const createCustomSize = createAsyncThunk(
//   "customSize/create",
//   async (sizeData, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");
      

//       console.log("🟡 Sending API Request:", sizeData);

//       const response = await axios.post(`${API_ENDPOINTS.customSize}`, sizeData, {
//         headers: { Authorization: token, "Content-Type": "application/json" },  // ✅ Proper Headers
//       });

//       console.log("🟢 API Response Data:", response.data);
//       return response.data;  // ✅ Ensure it returns API data
//     } catch (error) {
//       console.error("🔴 API Error:", error.response?.data || error.message);
//       return rejectWithValue(error.response?.data || "API request failed!");
//     }
//   }
// );


// // PUT: Update an existing custom size
// export const updateCustomSize = createAsyncThunk(
//   "customSize/update",
//   async (data, { rejectWithValue }) => {
//     try {
//       if (!data._id) throw new Error("Invalid update: Missing `_id`");  // ✅ Check `_id`

//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized");
      

//       const response = await axios.put(`${API_ENDPOINTS.updateCustomSize}/${data._id}`, data, {
//         headers: { Authorization: token },
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message || "Update failed!");
//     }
//   }
// );



// // GET: Fetch all custom sizes for a user
// export const fetchAllCustomSizes = createAsyncThunk(
//   "customSize/fetchAll",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");
      

//       const response = await axios.get(`${API_ENDPOINTS.customSize}`, {
//         headers: { Authorization: token },
//       });

//       // ✅ Filter only sizes that are saved for next time
//       // const filteredSizes = response.data.filter(size => size.savedForNextTime);

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "API request failed!");
//     }
//   }
// );


// // GET: Fetch a custom size by ID
// export const fetchCustomSizeById = createAsyncThunk(
//   "customSize/fetchById",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_ENDPOINTS.customSize}${id}`, {
//         headers: { Authorization: getAuthToken() },
        
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Redux Slice
// const customSizeSlice = createSlice({
//   name: "customSize",
//   initialState: {
//     sizes: [],
//     currentSize: null,
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(createCustomSize.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(createCustomSize.fulfilled, (state, action) => {
//         state.loading = false;
//         state.sizes = [...state.sizes, action.payload]; // ✅ Safe update
//     })
    
//       .addCase(createCustomSize.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       .addCase(updateCustomSize.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateCustomSize.fulfilled, (state, action) => {
//         state.loading = false;
//         state.sizes = state.sizes.map((size) =>
//           size._id === action.payload._id ? action.payload : size
//         );
//       })
      
//       .addCase(updateCustomSize.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

      
//       .addCase(fetchAllCustomSizes.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchAllCustomSizes.fulfilled, (state, action) => {
//         state.loading = false;
//         state.sizes = action.payload;  // ✅ Store only saved sizes
//       })
//       .addCase(fetchAllCustomSizes.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       .addCase(fetchCustomSizeById.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchCustomSizeById.fulfilled, (state, action) => {
//         state.loading = false;
//         state.currentSize = action.payload;
//       })
//       .addCase(fetchCustomSizeById.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default customSizeSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

// Get authentication token
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

// POST: Create a new custom size
export const createCustomSize = createAsyncThunk(
  "customSize/create",
  async (sizeData, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      const response = await axios.post(`${API_ENDPOINTS.customSize}`, sizeData, {
        headers: { Authorization: token, "Content-Type": "application/json" },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "API request failed!");
    }
  }
);

// PUT: Update an existing custom size
export const updateCustomSize = createAsyncThunk(
  "customSize/update",
  async (data, { rejectWithValue }) => {
    try {
      if (!data._id) throw new Error("Invalid update: Missing `_id`");

      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized");

      const response = await axios.put(`${API_ENDPOINTS.updateCustomSize}/${data._id}`, data, {
        headers: { Authorization: token },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Update failed!");
    }
  }
);

// DELETE: Remove a custom size
export const deleteCustomSize = createAsyncThunk(
  "customSize/delete",
  async (_id, { rejectWithValue }) => {
    try {
      if (!_id) throw new Error("Invalid delete: Missing `_id`");

      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized");

      await axios.delete(`${API_ENDPOINTS.customSize}/${_id}`, {
        headers: { Authorization: token },
      });

      return _id; // Returning the deleted size's ID for easy removal from state
    } catch (error) {
      return rejectWithValue(error.response?.data || "Delete failed!");
    }
  }
);
// export const saveCustomSizeId = 

// GET: Fetch all custom sizes for a user
export const fetchAllCustomSizes = createAsyncThunk(
  "customSize/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      const response = await axios.get(`${API_ENDPOINTS.customSize}`, {
        headers: { Authorization: token },
      });

      // Return only the `data` array from the response
      return response.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || "API request failed!");
    }
  }
);


// GET: Fetch a custom size by ID
export const fetchCustomSizeById = createAsyncThunk(
  "customSize/fetchById",
  async (_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_ENDPOINTS.customSize}${_id}`, {
        headers: { Authorization: getAuthToken() },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Fetch failed!");
    }
  }
);

// Redux Slice
const customSizeSlice = createSlice({
  name: "customSize",
  initialState: {
    sizes: [],
    currentSize: null,
    loading: false,
    error: null,
    customSizeId: null, // Add this line
  },
  reducers: {
    setCustomSizeId: (state, action) => {
      state.customSizeId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createCustomSize.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCustomSize.fulfilled, (state, action) => {
        state.loading = false;
        // if (!Array.isArray(state.sizes)) state.sizes = []; // Ensure sizes is always an array
        if (action.payload) state.sizes.push(action.payload); // Add payload only if valid
    })
    
      .addCase(createCustomSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCustomSize.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCustomSize.fulfilled, (state, action) => {
        state.loading = false;
        state.sizes = state.sizes.map((size) =>
          size._id === action.payload._id ? action.payload : size
        );
      })
      .addCase(updateCustomSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAllCustomSizes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllCustomSizes.fulfilled, (state, action) => {
        state.loading = false;
        state.sizes = action.payload; // Replace entire sizes array
      })
      
      
      .addCase(fetchAllCustomSizes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCustomSizeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomSizeById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentSize = action.payload;
      })
      .addCase(fetchCustomSizeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE case handling
      .addCase(deleteCustomSize.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCustomSize.fulfilled, (state, action) => {
        state.loading = false;
        state.sizes = Array.isArray(state.sizes) ? state.sizes.filter((size) => size._id !== action.payload) : [];

      })
      .addCase(deleteCustomSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCustomSizeId } = customSizeSlice.actions;
export default customSizeSlice.reducer;
